// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"f695074a","449":"f615ed70","482":"8509ee49","851":"3bed1c47"}[chunkId] + ".chunk.js";
};